export const ValidationMessagesTexts = {
  CREATE_GENERATE_REPORT: {
    REPORT_TYPE_REQUIRED: 'Report Type is required.',
    PROJECT_ID_REQUIRED: 'Project Number is required',
    PROJECT_ID_MAX_LENGTH: 'Project Number must not exceed 8 digits',
    STATE_REQUIRED: 'State is required.',
    CLIENT_REQUIRED: 'Client Name is required.',
    LOCATION_REQUIRED: 'Site or Project Number is required',
    REPORT_NAME_REQUIRED: 'Report Name/Title is required.',
    REFERENCE_REPORT_MONTH_REQUIRED: 'Reference Report Month is required.',
    REPORT_MONTH_REQUIRED: 'Report Month is required.',
    MISSING_FILE_ID_OR_REFERENCE_PATH: 'Missing file ID or reference path. Please re-select the reference document.',
    UPLOAD_SOURCE_FILES: 'Please upload source files before generating the report.'
  },
  TOASTER: {
    SUCCESS: {
      TYPE: 'success',
      TITLE: 'Success',
    },
    ERROR: {
      TYPE: 'error',
      TITLE: 'Error',
      SOMETHING_WENT_WRONG:'Something went wrong.',
      NO_SECTION_SELECTED: 'No section selected.Please select at least one section to send for rework.'
    },
    WARNING:{
      TYPE: 'warning',
      TITLE: 'Warning',
    }
  },
  REPORT_SECTION:{
    SECTION_NUMBER_REQUIRED:'Section number is required.',
    POSITION_REQUIRED:'Postion is required.',
    SECTION_TITLE_REQUIRED:'Section title is required.',
    SELECT_REVIEWER:'Please select a reviewer for approval.'
  },
  UPDATE_FROM_DATA: {
    NO_FILES_SELECTED: 'No files selected',
    PRIOR_REPORT_EXTENSION_INVALID: 'Prior Report must be a .docx or .dotx file.',
    DATA_FILES_EXTENSION_INVALID: 'Data Files must be .xlsx, .xls, or .csv.',
    SINGLE_DATA_FILE_ONLY: 'Only one data file can be uploaded.',
    ADDITIONAL_FILE_EXTENSION_INVALID: 'Additional section file must be a PDF.',
    SECTION_LABEL_REQUIRED: 'Section label is required when an additional file is selected.',
    SECTION_FILE_REQUIRED: 'PDF attachment is required when a section label is provided.',
    TOTAL_SIZE_LIMIT_EXCEEDED: 'Total selected file size cannot exceed 500 MB.',
    MAX_FILES_ALLOWED: 'Up to {maxFiles} files are allowed across Prior Report, Data Files, and Additional sections.',
    DUPLICATE_FILE_NAMES: 'Duplicate file names are not allowed: {duplicates}',
    FILE_ALREADY_SELECTED: 'A file named "{fileName}" is already selected.',
    FILE_EMPTY_BYTES: '"{fileName}" is empty (0 bytes).',
    FILE_EXCEEDS_MAX_SIZE: '"{fileName}" exceeds 100 MB.',
    FILE_UNREADABLE: 'Unable to read "{fileName}". The file may be corrupted.',
    PDF_INVALID: '"{fileName}" appears to be corrupted or is not a valid PDF.',
    PDF_INCOMPLETE: '"{fileName}" appears to be incomplete or corrupted.',
    PDF_PASSWORD_PROTECTED: '"{fileName}" is password-protected. Please provide an unlocked PDF.',
    OPENXML_INVALID_OR_PROTECTED: '"{fileName}" appears to be password-protected or not a valid Open XML file.',
    FILE_CORRUPTED: '"{fileName}" appears to be corrupted.',
    OPENXML_INVALID_STRUCTURE: '"{fileName}" appears to be corrupted or has an invalid internal structure.',
    XLS_INVALID: '"{fileName}" appears to be corrupted or is not a valid .xls file.',
    FILE_PASSWORD_PROTECTED: '"{fileName}" is password-protected. Please provide an unlocked file.',
    CSV_INVALID: '"{fileName}" appears to be corrupted or is not a valid CSV file.',
    FILE_EMPTY: '"{fileName}" is empty.'
  }
};